export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";